import { render, staticRenderFns } from "./InvestorAnalysisReport.vue?vue&type=template&id=c60739b6&scoped=true&"
import script from "./InvestorAnalysisReport.vue?vue&type=script&lang=js&"
export * from "./InvestorAnalysisReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60739b6",
  null
  
)

export default component.exports